import { render, staticRenderFns } from "./LinkCoupon.vue?vue&type=template&id=9b9584c4&scoped=true&"
import script from "./LinkCoupon.vue?vue&type=script&lang=ts&"
export * from "./LinkCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./LinkCoupon.vue?vue&type=style&index=0&id=9b9584c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9584c4",
  null
  
)

export default component.exports